export default {
  formatNumber(val) {
    let res = 0;

    if (val >= 100) {
      res = Math.round(val);
    }

    if (val >= 10 && val < 100) {
      res = Math.round(val * 10) / 10;
    }

    if (val < 10) {
      res = Math.round(val * 100) / 100;
    }

    return res;
  },
};
